import React from 'react'
import './index.less'

export default function Rhyme(props) {
  const { currentTags } = props
  // console.log(currentTags, "currentTags")

  return (
    <div className='rhyme-total'>
      <div className='rhyme-wrapper'>
        {currentTags.map((item) => {
          return (
            <div className='rhyme-tags' key={item}>
              {item}
            </div>
          )
        })}
      </div>
    </div>
  )
}
